"use strict";
/**
 * The AI service's contract for provider fallback (apps/ai/app/schemas.py): which provider and
 * model ran a step, and what was tried before it.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_UNAVAILABLE_REASON = void 0;
/** lastIntakeError of an order that gave up because no AI provider answered for an hour. */
exports.AI_UNAVAILABLE_REASON = 'AI unavailable';
//# sourceMappingURL=ai.js.map